<div class="company-details">
  <div class="row mb-3">
    <div class="col-md-6 mb-3 col-12">
      <span class="p-text-grey">Razão social</span>
      <p class="p-text-grey-dark">{{ cpoData?.companyName }}</p>
    </div>
    <div class="col-md-6 col-12">
      <span class="p-text-grey">CNPJ</span>
      <p class="p-text-grey-dark">
        {{ cpoData?.cnpj | mask : "AA.AAA.AAA/AAAA-00" }}
      </p>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-6 mb-3 col-12">
      <span class="p-text-grey">E-mail</span>
      <p class="p-text-grey-dark">{{ cpoData?.contact?.email }}</p>
    </div>
    <div class="col-md-6 col-12">
      <span class="p-text-grey">Telefone</span>
      <p class="p-text-grey-dark">
        {{
          cpoData?.contact?.phone | mask : "(00) 00000-0000 || (00) 0000-0000"
        }}
      </p>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-6 mb-3 col-12">
      <span class="p-text-grey"> Setor de atuação</span>
      <p class="p-text-grey-dark">{{ cpoData?.businessSector }}</p>
    </div>
    <div class="col-md-6 col-12">
      <span class="p-text-grey">Endereço</span>
      <p class="p-text-grey-dark">
        {{ cpoData?.contact?.address?.line1 }} -
        {{ cpoData?.contact?.address?.number }} -
        {{ cpoData?.contact?.address?.line2 }} -
        {{ cpoData?.contact?.address?.line3 }} -
        {{ cpoData?.contact?.address?.city }} -
        {{ cpoData?.contact?.address?.state }} -
        {{ cpoData?.contact?.address?.postalCode | mask : "00000-000" }}
      </p>
    </div>
  </div>
  <div class="document-section mt-4 p-3 border rounded">
    <h5>Documentos gerais</h5>
    <div
      *ngIf="cpoData?.socialContract"
      class="d-flex align-items-center gap-2 tappable download-container"
    >
      <img src="assets/image/clip-icon.svg" alt="Clip Icon" />
      <span class="archive-name">Contrato Social</span>
      <div
        class="ms-auto d-flex gap-2 align-items-center"
        (click)="downloadAttachmentByName(cpoData?.socialContract)"
      >
        <a download class="text-decoration-none">
          <span class="text-blue">Baixar</span>
        </a>
        <img src="assets/image/download-icon.svg" alt="Baixar" />
      </div>
    </div>
    <div
      *ngIf="cpoData?.residentialProof"
      class="d-flex align-items-center gap-2 tappable download-container"
    >
      <img src="assets/image/clip-icon.svg" alt="Clip Icon" />
      <span class="archive-name">Comprovante de residência</span>
      <div
        class="ms-auto d-flex gap-2 align-items-center"
        (click)="downloadAttachmentByName(cpoData?.residentialProof)"
      >
        <a download class="text-decoration-none">
          <span class="text-blue">Baixar</span>
        </a>
        <img src="assets/image/download-icon.svg" alt="Baixar" />
      </div>
    </div>
  </div>
</div>
